<template>
	<v-layout style = 'flex: 0 0 auto !important;'>
		<v-btn small depressed icon @click.stop.prevent='visibility = true;' class = 'mx-0'><v-icon small :color = '$store.getters.uiAccentIcon'>delete_outline</v-icon></v-btn>
		<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
			<template v-slot:title>{{notification.rules.name}}</template>
			<template v-slot:content>
				<div class = 'py-2'>Удалить оповещение?</div>
			</template>
			<template v-slot:action>
				<v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteNotification'>Удалить</v-btn>
			</template>
		</dialog-generic>
	</v-layout>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

	export default {
		name: 'NotificationDeleteDialog',
		props: ['data', 'projectId'],
		components: {'dialog-generic': DialogGeneric},
		data() {
			return {
				visibility: false,
				notification: this.data,
				indicator: false,
			}
		},
		methods: {
			deleteNotification() {
				this.indicator = true;
				let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8'
		        };
		        let requestData = {
		          'login': this.$store.getters.userLogin,
		          'notification': this.notification.pp_id
		        }
		        this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.projectId + '/notifications/delete',
		          requestData,
		          {headers: {...this.$store.state.restrictedHeaders,...requestHeaders}}
		        ).then( (r) => {
					this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'notification'
                            },
                            once: false
                        })
		        	this.$store.dispatch('requestUserNotifications')
		        	this.visibility = false;
		        	this.indicator = false;
		        });
			}
		}
	}
</script>